module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home",
    style: ({
      backgroundImage: 'url(' + _vm.content.video.poster + ')'
    })
  }, [_c('video', {
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.video.mp4,
      "type": "video/mp4"
    }
  }), _c('source', {
    attrs: {
      "src": _vm.content.video.webm,
      "type": "video/webm"
    }
  }), _c('p', [_vm._v("Your browser doesn't support HTML5 video. Here is a"), _c('a', {
    attrs: {
      "href": _vm.content.video.youtube
    }
  }, [_vm._v("link to the video instead.")])])]), _c('div', {
    staticClass: "hero-home__overlay"
  }, [_c('div', {
    staticClass: "hero-home__tagline"
  }, [_c('Icon', {
    attrs: {
      "name": "logo-white"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b26712e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/home/hero-home.pug
// module id = 506
// module chunks = 1